const GRAPHEME_SEGMENTER = new Intl.Segmenter('ko', {
  granularity: 'grapheme',
});
//* 절단되면 종료문자가 잘려나가 오버라이드가 주변 UI 문구까지 뒤집는다. ZWJ·ZWNJ는 이모지·아랍어 표기에 쓰이므로 남긴다.
const BIDI_CONTROL_PATTERN =
  /[\u200B\u200E\u200F\u202A-\u202E\u2066-\u2069\uFEFF]/g;

export const stripBidiControls = (text: string) =>
  text.replaceAll(BIDI_CONTROL_PATTERN, '');

export const truncateGraphemes = (text: string, maxLength: number) => {
  const graphemes = [...GRAPHEME_SEGMENTER.segment(text)];

  return graphemes.length > maxLength
    ? graphemes
        .slice(0, maxLength)
        .map(({ segment }) => segment)
        .join('')
    : text;
};

export const toTextPreview = (text: string, maxLength: number) => {
  const sanitized = stripBidiControls(text);
  const preview = truncateGraphemes(sanitized, maxLength);

  return { text: sanitized, preview, isTruncated: preview !== sanitized };
};
